import {ChangeDetectionStrategy, Component, computed} from "@angular/core"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent, SelectionPossibilities} from "@template-editor/components/value-slot/value-slot.component"
import {findClosestParentComponentGraph, collectMattressNodes, isMattressReferenceFrameLikeNode, isMattressCurveLikeNode} from "@cm/mattress-nodes"
import type {MattressInput, MattressCurveLikeNode, MattressReferenceFrameLikeNode} from "@cm/mattress-nodes"

@Component({
    selector: "cm-mattress-input-inspector",
    templateUrl: "./mattress-input-inspector.component.html",
    styleUrl: "./mattress-input-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MattressInputInspectorComponent extends BaseInspectorComponent<MattressInput> {
    readonly $curveInput = computed(() => {
        const node = this.$node()
        if (isMattressCurveLikeNode(node)) return node
        else return null
    })
    readonly $curveInputSelectionPossibilities = computed<SelectionPossibilities<MattressCurveLikeNode | null>>(() => {
        const input = this.$curveInput()
        if (!input) return []
        const parentGraph = findClosestParentComponentGraph(input)
        const availableCurves = Array.from(collectMattressNodes(parentGraph, isMattressCurveLikeNode)).filter((curve) => curve !== input)
        return [{name: "None", value: null}, ...availableCurves.map((curve) => ({name: curve.parameters.name, value: curve}))]
    })

    readonly $referenceFrameInput = computed(() => {
        const node = this.$node()
        if (isMattressReferenceFrameLikeNode(node)) return node
        else return null
    })
    readonly $referenceFrameInputSelectionPossibilities = computed<SelectionPossibilities<MattressReferenceFrameLikeNode | null>>(() => {
        const input = this.$referenceFrameInput()
        if (!input) return []
        const parentGraph = findClosestParentComponentGraph(input)
        const availableReferenceFrames = Array.from(collectMattressNodes(parentGraph, isMattressReferenceFrameLikeNode)).filter((rf) => rf !== input)
        return [{name: "None", value: null}, ...availableReferenceFrames.map((rf) => ({name: rf.parameters.name, value: rf}))]
    })
}
